export enum Topic {
  GENERAL_INQUIRY = 'general inquiry',
  SPECIFIC_ORDER = 'specific order',
  ORDER_FROM_CONTEXT = 'order from context',
}
